import { getLocale } from "@/utils/helper";
import { INTL } from "@/constants";

export async function initAccountData({ dispatch, commit, getters, state }) {
  const inited = state.app.inited;
  const logged = getters["auth/isLogged"];
  if (logged) {
    if (!inited) {
      const locale = getLocale();
      const currency = INTL[locale].currency;
      const setting = state.app.settings;
      commit("app/SET_SETTINGS", { ...setting, currency });
      commit("app/SET_INITING", true);
    }
    try {
      await Promise.all([
        dispatch("app/loadConfig"),
        dispatch("basis/account/loadProfile"),
        dispatch("wallet/mixin/loadAssets"),
        dispatch("hfox/loadHfoxData"),
        // dispatch("defi/account/loadWealthes"),
        dispatch("market/loadRate")
      ]);
      commit("app/SET_INITING", false);
      commit("app/SET_INITED", true);
    } catch (error) {
      commit("app/SET_INITING", false);
    }
  }
}

export function removeAccountData({ dispatch }) {
  dispatch("app/removeAppInfo", {}, { root: true });
  dispatch("market/removeProcessOrder", {}, { root: true });
  dispatch("basis/account/removeAccountData", {}, { root: true });
  dispatch("defi/removeDefiData", {}, { root: true });
  dispatch("hfox/removeHfoxData", {}, { root: true });
  dispatch("trade/removeTradeData", {}, { root: true });
  dispatch("wallet/removeWalletData", {}, { root: true });
}

export function removeMixinBindData({ dispatch }) {
  dispatch("wallet/removeWalletData");
}
